module.exports = __webpack_public_path__ + "img/Henkel.3383c7c8.png";